export default __webpack_public_path__ + "static/media/backoffice-invoices.0bccb997.jpg";